import { ActionType, ActionTypes, State } from './types';

const initialState = {
  items: [],
  canShow: true,
};

const notificationsReducer = (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case ActionTypes.ADD_NOTIFICATION:
      return {
        ...state,
        items: [...state.items, action.payload],
      };
    case ActionTypes.REMOVE_NOTIFICATION:
      return {
        ...state,
        items: state.items.filter((n) => n.id !== action.payload),
      };
    case ActionTypes.SET_CAN_SHOW:
      return {
        ...state,
        canShow: action.payload,
      };
    default:
      return state;
  }
};

export default notificationsReducer;
